import { ModalFooter } from 'reactstrap'
import React from 'react'
import Resx from '@/components/Resx'
import { Button } from '@/components/button'

export const ConfirmFooter = ({ closeDialog, onAction, primaryButtonText, icon, disabled }) => {
  return (
    <ModalFooter>
      <Button color='success' onClick={() => onAction()} icon={icon} disabled={disabled}>
        <span><Resx name={primaryButtonText || 'Common.Confirm'} /></span>
      </Button>
      <Button onClick={() => closeDialog()}>
        <Resx name='Common.Cancel' />
      </Button>
    </ModalFooter>
  )
}



// WEBPACK FOOTER //
// ./src/dialogs/common/confirmFooter.js